export default __webpack_public_path__ + "static/media/pump.ba3944c2.png";